import React, { useEffect, useState } from "react";
import "./index.scoped.css";
// import "./NoteNumber.css";

import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";
export default function NoteNumber() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "notenum";
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
      // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
      //  VIDEO_ID={GAME_ID}
      // GAME_ID={GAME_ID}
      // shortName={"cards32a cards32b"}
      // gameName={"CARDS 32B"}
    >
      {/* <div className="clock flip-clock-wrapper">
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">1</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      {/* </div> */}
      <div className="casino-detail note-number">
        <div className="casino-table">
          <div className="casino-table-box">
            <div className="casino-odd-box-container-box">
              <div className="casino-odd-box-container">
                <div className="casino-nation-name">
                  <span className="me-2">Odd Card 5</span>
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/A.jpg" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/3.jpg" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/5.jpg" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/7.jpg" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/9.jpg" />
                </div>
                {/* <div className="casino-odds-box back"> */}
                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Odd Card 5", casinoData, dispatch, "back")
                  }
                >
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("Odd Card 5", casinoData, true)}
                  </span>
                  {/* </div> */}
                </div>
                {/* <div className="casino-odds-box lay"> */}
                <div
                  className={`casino-odds-box lay  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Odd Card 5", casinoData, dispatch, "lay")
                  }
                >
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("Odd Card 5", casinoData, false)}
                  </span>
                  {/* </div> */}
                </div>
                {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(casinoPlData, "Odd Card 5")}
                </div>
                {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(casinoPlData, "Even Card 5")}
                </div>
              </div>
              <div className="casino-odd-box-container">
                <div className="casino-nation-name">
                  <span className="me-2">Even Card 5</span>
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/2.jpg" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/4.jpg" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/6.jpg" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/8.jpg" />
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/10.jpg" />
                </div>
                {/* <div className="casino-odds-box back">
                      <span className="casino-odds">1.98</span>
                    </div>
                    <div className="casino-odds-box lay">
                      <span className="casino-odds">2.02</span>
                    </div>
                    <div className="casino-nation-book text-center w-100" />
                  </div> */}

                {/* <div className="casino-odds-box back"> */}
                <div
                  className={`casino-odds-box back  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Even Card 5", casinoData, dispatch, "back")
                  }
                >
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("Even Card 5", casinoData, true)}
                  </span>
                  {/* </div> */}
                </div>
                {/* <div className="casino-odds-box lay"> */}
                <div
                  className={`casino-odds-box lay  ${
                    casinoData?.data?.response?.autoTime < 5
                      ? "suspended-box"
                      : ""
                  }`}
                  onClick={() =>
                    setBet("Even Card 5", casinoData, dispatch, "lay")
                  }
                >
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("Even Card 5", casinoData, false)}
                  </span>
                  {/* </div> */}
                </div>
                {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
                <div className="casino-nation-book text-center d-none d-md-block w-100">
                  {getCasinoPlExposureByRunner(casinoPlData, "Even Card 5")}
                </div>
              </div>
              <div className="casino-odd-box-container-box">
                <div className="casino-odd-box-container">
                  <div className="casino-nation-name">
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/spade.png" />
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/club.png" />
                  </div>
                  {/* <div className="casino-odds-box back">
                    <span className="casino-odds">1.98</span>
                  </div>
                  <div className="casino-odds-box lay">
                    <span className="casino-odds">2.02</span>
                  </div>
                  <div className="casino-nation-book text-center w-100" />
                </div> */}

                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Card 5", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Card 5", casinoData, true)}
                    </span>
                    {/* </div> */}
                  </div>
                  {/* <div className="casino-odds-box lay"> */}
                  <div
                    className={`casino-odds-box lay  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Card 5", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Card 5", casinoData, false)}
                    </span>
                    {/* </div> */}
                  </div>
                  {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
                  <div className="casino-nation-book text-center d-none d-md-block w-100">
                    {getCasinoPlExposureByRunner(casinoPlData, "Card 5")}
                  </div>
                </div>

                <div className="casino-odd-box-container">
                  <div className="casino-nation-name">
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/heart.png" />
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/icons/diamond.png" />
                  </div>
                  {/* <div className="casino-odds-box back">
                    <span className="casino-odds">1.98</span>
                  </div>
                  <div className="casino-odds-box lay">
                    <span className="casino-odds">2.02</span>
                  </div>
                  <div className="casino-nation-book text-center w-100" />
                </div> */}

                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Card 5", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Card 5", casinoData, true)}
                    </span>
                    {/* </div> */}
                  </div>
                  {/* <div className="casino-odds-box lay"> */}
                  <div
                    className={`casino-odds-box lay  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Card 5", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Card 5", casinoData, false)}
                    </span>
                    {/* </div> */}
                  </div>
                  {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
                  <div className="casino-nation-book text-center d-none d-md-block w-100">
                    {getCasinoPlExposureByRunner(casinoPlData, "Card 5")}
                  </div>
                </div>
              </div>
              <div className="casino-odd-box-container-box">
                <div className="casino-odd-box-container">
                  <div className="casino-nation-name">
                    <span className="me-2">Low Card 5</span>
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/A.jpg" />
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/2.jpg" />
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/3.jpg" />
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/4.jpg" />
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/5.jpg" />
                  </div>
                  {/* <div className="casino-odds-box back">
                    <span className="casino-odds">2.03</span>
                  </div>
                  <div className="casino-odds-box lay">
                    <span className="casino-odds">2.07</span>
                  </div>
                  <div className="casino-nation-book text-center w-100" />
                </div> */}

                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Low Card 5", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Low Card 5", casinoData, true)}
                    </span>
                    {/* </div> */}
                  </div>
                  {/* <div className="casino-odds-box lay"> */}
                  <div
                    className={`casino-odds-box lay  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Low Card 5", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Low Card 5", casinoData, false)}
                    </span>
                    {/* </div> */}
                  </div>
                  {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
                  <div className="casino-nation-book text-center d-none d-md-block w-100">
                    {getCasinoPlExposureByRunner(casinoPlData, "Low Card 5")}
                  </div>
                </div>

                <div className="casino-odd-box-container">
                  <div className="casino-nation-name">
                    <span className="me-2">High Card 5</span>
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/6.jpg" />
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/7.jpg" />
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/8.jpg" />
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/9.jpg" />
                    <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/single/10.jpg" />
                  </div>
                  {/* <div className="casino-odds-box back">
                    <span className="casino-odds">1.93</span>
                  </div>
                  <div className="casino-odds-box lay">
                    <span className="casino-odds">1.97</span>
                  </div>
                  <div className="casino-nation-book text-center w-100" />
                </div> */}

                  {/* <div className="casino-odds-box back"> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("High Card 5", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("High Card 5", casinoData, true)}
                    </span>
                    {/* </div> */}
                  </div>
                  {/* <div className="casino-odds-box lay"> */}
                  <div
                    className={`casino-odds-box lay  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("High Card 5", casinoData, dispatch, "lay")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("High Card 5", casinoData, false)}
                    </span>
                    {/* </div> */}
                  </div>
                  {/* <div className="casino-nation-book text-center d-none d-md-block w-100" /> */}
                  <div className="casino-nation-book text-center d-none d-md-block w-100">
                    {getCasinoPlExposureByRunner(casinoPlData, "High Card 5")}
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-table-box mt-3">
              <div className="casino-table-left-box">
                <div className="casino-odd-box-container">
                  <div className="casino-nation-name">
                    <b>Baccarat 1</b>
                    <span className="">(1st, 2nd, 3rd card)</span>
                  </div>
                  <div className="casino-odds-box back ">
                    {/* <span className="casino-odds">2.05</span>
                    <div className="casino-nation-book text-center" />
                  </div>
                </div> */}

                    <div
                      className={`casino-odds-box back  ${
                        casinoData?.data?.response?.autoTime < 5
                          ? "suspended-box"
                          : ""
                      }`}
                      onClick={() =>
                        setBet("Baccarat 1", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Baccarat 1", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="casino-nation-name">
                  <b>Baccarat 2</b>
                  <span className="">(4th, 5th, 6th card)</span>
                </div>
                <div className="casino-odds-box back ">
                  {/* <div className="casino-nation-name">
                    <b>Baccarat 2</b>
                    <span className="">(4th, 5th, 6th card)</span>
                  </div>
                  <div className="casino-odds-box back suspended-box">
                    <span className="casino-odds">2.05</span>
                    <div className="casino-nation-book text-center" />
                  </div>
                </div> */}
                  <div
                    className={`casino-odds-box back  ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet("Baccarat 2", casinoData, dispatch, "back")
                    }
                  >
                    <span className="casino-odds">
                      {" "}
                      {getOddForEntity("Baccarat 2", casinoData, true)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="casino-table-right-box">
              <div className="card-odd-box">
                <div className="casino-odds">9</div>
                <div className="">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/A.png" />
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div className="casino-odds">9</div>
                <div className="">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/2.png" />
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div className="casino-odds">9</div>
                <div className="">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/3.png" />
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div className="casino-odds">9</div>
                <div className="">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/4.png" />
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div className="casino-odds">9</div>
                <div className="">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/5.png" />
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div className="casino-odds">9</div>
                <div className="">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/6.png" />
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div className="casino-odds">9</div>
                <div className="">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/7.png" />
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div className="casino-odds">9</div>
                <div className="">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/8.png" />
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div className="casino-odds">9</div>
                <div className="">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/9.png" />
                </div>
                <div className="casino-nation-book" />
              </div>
              <div className="card-odd-box">
                <div className="casino-odds">9</div>
                <div className="">
                  <img src="https://g1ver.sprintstaticdata.com/v50/static/front/img/cards/10.png" />
                </div>
                <div className="casino-nation-book" />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/notenum">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
              <span className="result result-b">R</span>
            </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>
  );
}
